import { DIV_ATTRS } from "../constants/domElConstants";

let counter = 0;

class DomTree {
  constructor({ start, end, attr, label, data }) {
    const fixedAttr = (attr || "").replace(/^mml:/, "");

    this.start = start;
    this.attr = attr;
    this.label = label;
    this.data = data;
    this.end = end;
    this.len = end - start;
    this.children = [];
    this.innerText = "";
    this.els = [];
    this.id = `el-${(counter += 1)}`;
    this.HtmlTag = DIV_ATTRS[fixedAttr] || fixedAttr || "span";
  }

  expandText(text) {
    const els = [];
    let leftOfTag = this.start;

    if (this.children.length === 0) {
      this.innerText = text.slice(this.start, this.end);
      return this;
    }

    for (let i = 0; i < this.children.length; i++) {
      const domEl = this.children[i];
      const leftSection = new DomTree({ start: leftOfTag, end: domEl.start });

      leftSection.expandText(text);
      domEl.expandText(text);

      els.push(leftSection);
      els.push(domEl);

      leftOfTag = domEl.end;
    }

    const rightSection = new DomTree({ start: leftOfTag, end: this.end });
    rightSection.expandText(text);

    els.push(rightSection.expandText(text));

    this.els = els.filter((x) => x.start < x.end);

    return this;
  }

  canFit(other) {
    return this.start <= other.start && this.end >= other.end;
  }

  getIntersectPoint(other) {
    if (this.start <= other.start && this.end > other.start) {
      return other.start;
    }
    if (this.start < other.end && this.end >= other.end) {
      return other.end;
    }
    return null;
  }

  clear() {
    this.children.forEach((x) => x.clear());
    this.els = [];
    this.children = [];
  }

  split(point) {
    return [
      new DomTree({
        start: this.start,
        end: point,
        attr: this.attr,
        label: this.label,
        data: this.data,
      }),
      new DomTree({
        start: point,
        end: this.end,
        attr: this.attr,
        label: this.label,
        data: this.data,
      }),
    ];
  }

  addChild(other) {
    if (!this.canFit(other)) return;
    const child = this.children.find((x) => x.canFit(other));
    if (child) {
      child.addChild(other);
      return;
    }

    const intersected = this.children.find((x) => x.getIntersectPoint(other));

    if (intersected) {
      const interPoint = intersected.getIntersectPoint(other);
      const splited = other.split(interPoint + 1);
      splited.forEach((x) => this.addChild(x));
      return;
    }

    this.children.push(other);
    this.children.sort((a, b) => a.start - b.start || b.end - a.end);
  }

  setChildren(els) {
    els
      .sort((a, b) => a.start - b.start || b.len - a.len)
      .forEach((x) => this.addChild(x));

    return this;
  }
}

export default DomTree;
